import React from 'react';
import PropTypes from 'prop-types';
import SectionHeader from 'partial/components/SectionHeader';
import GridCms from './GridCms';

const useCmsList = () => {
  const [list] = React.useState([
    {
      id: 1,
      label: 'Bills',
      photo_url: 'https://ucarecdn.com/3e0dc455-fbab-4a3b-834f-c0f2127e9c4a/',
      description: 'Pay Bills',
      enabled: true,
    },
    {
      id: 2,
      label: 'Shopping',
      photo_url: 'https://ucarecdn.com/f0275480-5ea8-46cc-9c1d-32b8545dcba5/',
      description: 'Online Shopping',
      enabled: true,
    },
    {
      id: 3,
      label: 'Load',
      photo_url: 'https://ucarecdn.com/8a3edb28-70cf-4744-8d8f-2a6956be8917/',
      description: 'Buy Load',
      enabled: true,
    },
  ]);
  const [list2] = React.useState([
    {
      id: 4,
      label: 'Ticket',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 5,
      label: 'Module 5',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 6,
      label: 'Module 6',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 7,
      label: 'Module 7',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 8,
      label: 'Module 8',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 9,
      label: 'Module 9',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 10,
      label: 'Module 10',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 11,
      label: 'Module 11',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 12,
      label: 'Module 12',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 13,
      label: 'Module 13',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
    {
      id: 14,
      label: 'Module 14',
      photo_url: 'https://ucarecdn.com/429e5dde-838d-419c-9034-a6f5f6f19d30/',
      description: 'Buy Ticket',
      enabled: false,
    },
  ]);
  return [false, list, list2];
};

function Services({ data, onSelect }) {
  const [isLoading, enabledList, disabledList] = useCmsList();
  const handleSelect = (row) => {
    onSelect(row);
  };
  return (
    <>
      <div className="px-4 pt-5">
        <SectionHeader label={data.label} />
      </div>
      <div className="p-6">
        <div className="relative">
          <div
            className="absolute inset-0 flex items-center"
            aria-hidden="true"
          >
            <div className="w-full border-t border-dashed border-gray-200" />
          </div>
          <div className="relative flex justify-start">
            <span className="pr-2 bg-gray-100 text-sm font-medium text-gray-700">
              Enabled Modules
            </span>
          </div>
        </div>
        <GridCms
          isLoading={isLoading}
          data={enabledList}
          labelKey="label"
          photoKey="photo_url"
          subKey="description"
          onSelect={handleSelect}
          size="sm"
        />
        <div className="relative">
          <div
            className="absolute inset-0 flex items-center"
            aria-hidden="true"
          >
            <div className="w-full border-t border-dashed border-gray-200" />
          </div>
          <div className="relative flex justify-start">
            <span className="pr-2 bg-gray-100 text-sm font-medium text-gray-700">
              Disabled Modules
            </span>
          </div>
        </div>
        <GridCms
          isLoading={isLoading}
          data={disabledList}
          labelKey="label"
          photoKey="photo_url"
          subKey="description"
          onSelect={handleSelect}
          itemClassName="filter grayscale"
          size="sm"
        />
      </div>
    </>
  );
}

Services.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default Services;
